<template>
    <div class="post-container">
        <div class="top-container">
            <img @click="back" class="back" :src="Back" alt="Back">
            <h2>لیست پیام‌ها</h2>
        </div>

        <!-- MESSAGES LIST -->
        <div class="table-container" v-if="response.length">
            <table class="table table-hover">
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <!-- <th scope="col">خلاصه</th> -->
                    <th scope="col">تاریخ</th>
                    <th scope="col">عملیات‌ها</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in response" :key="index">
                        <th class="index" scope="row">{{ index + 1}}</th>
                        <!-- <td>{{ item.Text + item.Text | truncateText(15) }}</td> -->
                        <td>{{ item.Created_at | moment }}</td>
                        <td class="options">
                            <span 
                                @click="CheckText(item._id, item.Text)"
                            >جزئیات</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- EMPTY INBOX -->
        <div class="empty-container" v-else-if="!response.length">
            <h4>موردی یافت نگردید</h4>
        </div>
    </div>
</template>

<script>
import Back from '@/assets/images/courses/content/right-back.png';

import { getRequest } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';

import moment from 'moment-jalaali';

export default {
    name: 'Posts',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    data() {
        return {
            // list of our cases
            response: [],

            Back: Back,
            prevRoute: {},
        };
    },
    mounted() {
        this.GetAll();
    },
    filters: {
        // will show the date like 'Jun 24th 2020'
        moment: (date) => {
            return moment(date).format('jDD/jMMMM/jYYYY');
        }
    },
    methods: {
        // get list of all posts
        GetAll() {
            getRequest('/notifications/find-all')
                .then(rsp => {
                    // response
                    this.response = rsp.data;
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },

        // show confirm dialog for deleting 
        CheckText(id, txt) {
            getRequest('/notifications/read-one', {
                id: id
            })
                .then(() => {
                    this.$modal.show('dialog', {
                        title: 'توجه!',
                        text: txt,
                        buttons: [
                            {
                                title: 'تایید',
                                default: true,
                            }
                        ]
                    });
                })
        },

        back() {
            if(this.prevRoute.name) {
                this.$router.go(-1)
            } else {
                this.$router.push({ name: 'Khanesh' })
            }
        }
    }
}
</script>

<style scoped>
/* --------------------------------- */
/* ------------ GENERAL ------------ */
/* --------------------------------- */
.post-container {
    padding: 1rem 20px 15pt;
}
.post-container .top-container {
    display: flex;
    margin-bottom: 25px;
}
.post-container .top-container h5 {
    margin: 0pt auto 15pt;
    text-align: left;
}
.post-container .top-container .back {
    height: 40px;
    display: inline;

    margin-left: 15px;
}

/* --------------------------------- */
/* -------- TABLE CONTAINER -------- */
/* --------------------------------- */
.post-container table {
    margin-top: 0;
    margin-bottom: 0;
}
.post-container table td,
.post-container table th {
    vertical-align: middle;
}
.post-container .table-container {
    overflow: scroll;
    border: 1pt solid #ccc;
    max-height: calc(100vh - 65pt);
}
.post-container .table-container .index {
    width: 35pt;
}
.post-container .table-container .options {
    width: 100pt;
}
.post-container .table-container .options span {
    font-weight: 500;
}
.post-container .table-container .options span:hover {
    cursor: pointer;
    text-decoration: underline;
}

/* --------------------------------- */
/* -------- EMPTY CONTAINER -------- */
/* --------------------------------- */
.empty-container {
    margin: 0 5pt;
    padding: 15pt 25pt;
    
    border: 1pt solid #ccc;
    border-radius: 5pt;
    box-shadow: 2pt 2pt 5pt 0pt #efefef;
    background-color: #efefef;
}
</style>
